import { VFC } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';
import DatePickerInput from './DatePickerInput';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputMainContainer: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      minHeight: 60,
      alignItems: 'center',
      width: '100%'
    }
  })
);

type Props = {
  date: Date | null;
  onChange: (date: Date | null, value?: string | null | undefined) => void;
  id: string;
  emptyLabel?: string | null;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
};

const DatePickerInputField: VFC<Props> = props => {
  const classes = useStyles();

  return (
    <div className={classes.inputMainContainer}>
      <div
        style={{
          marginLeft: 10,
          marginRight: 15,
          backgroundColor: '#FFFFFF',
          height: 42,
          paddingBottom: 5,
          paddingLeft: 5,
          width: '100%'
        }}
        className={'select-div-div'}
      >
        <DatePickerInput {...props} />
      </div>
    </div>
  );
};

export default DatePickerInputField;
